import React from 'react'
import { FormattedMessage } from 'react-intl'
import { TooltipLabel } from '../../../design-system'
import { TooltipLabelText } from './tooltip-label-text'
import { ApplicationImportance } from '../../application-importance'

export const importanceTranslationIdLookup = {
  UNIMPORTANT: 'title_appImportanceLevelUnimportant',
  LOW: 'title_appImportanceLevelLow',
  MEDIUM: 'title_appImportanceLevelMedium',
  HIGH: 'title_appImportanceLevelHigh',
  CRITICAL: 'title_appImportanceLevelCritical'
}

export function Importance({
  importance
}: {
  readonly importance: ApplicationImportance
}) {
  return (
    <FormattedMessage id="title_importance_level">
      {(label) => {
        return (
          <TooltipLabel
            label={label as any}
            renderValue={() => {
              return (
                <FormattedMessage
                  id={importanceTranslationIdLookup[importance]}
                  defaultMessage={
                    importance.slice(0, 1).toUpperCase() +
                    importance.slice(1).toLowerCase()
                  }
                >
                  {(text) => <TooltipLabelText>{text}</TooltipLabelText>}
                </FormattedMessage>
              )
            }}
          />
        )
      }}
    </FormattedMessage>
  )
}
